import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import BillingDetails from "./components/BillingDetails";
import VegIcon from "./components/VegIcon";
import TextInput from "./components/TextInput";
import SubHeader from "./components/SubHeader";

interface PaidItem {
  id: string;
  code: string | number;
  name: string;
  qty: number;
  price: number;
  type: "veg" | "nonveg";
  orderedAt: string;
}

const ITEMS: PaidItem[] = [
  { id: "1", code: 220, name: "Thecha Paratha", qty: 1, price: 120, type: "veg", orderedAt: "05:55:00 PM" },
  { id: "2", code: 200, name: "Paneer Tikka", qty: 1, price: 100, type: "veg", orderedAt: "05:55:00 PM" },
];

const TIPS = [10, 12, 30, 40];

interface Offer {
  code: string;
  percent: number;
  description: string;
}

const OFFERS: Offer[] = [
  { code: "JUMBO", percent: 10, description: "Use code JUMBO & get 10% off on orders above ₹100." },
  { code: "NEW100", percent: 20, description: "Use code NEW100 & get 10% off on orders above ₹100." },
  { code: "SAVE50", percent: 15, description: "Use code SAVE50 & get 15% off on orders above ₹250." },
  { code: "WELCOME", percent: 25, description: "Use code WELCOME & get 25% off on your first order." },
];

const ChevronRight = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M9 6l6 6-6 6" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UpiLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="28" viewBox="0 0 72 28" fill="none">
    <path d="M2.04747 22.7825H2.56427L2.08028 24.7803C2.00645 25.0739 2.02286 25.3022 2.1213 25.449C2.21973 25.5958 2.4002 25.6691 2.67091 25.6691C2.93341 25.6691 3.15489 25.5958 3.32716 25.449C3.49942 25.3022 3.61426 25.0739 3.68809 24.7803L4.17208 22.7825H4.69708L4.20489 24.8292C4.09825 25.2696 3.90958 25.6039 3.63067 25.8241C3.35997 26.0443 2.99903 26.1584 2.55606 26.1584C2.11309 26.1584 1.80958 26.0524 1.64551 25.8322C1.48145 25.6121 1.44864 25.2777 1.55528 24.8374L2.04747 22.7825ZM4.62325 26.0687L5.44356 22.652L7.00216 24.658C7.04317 24.7151 7.08419 24.7721 7.1252 24.8374C7.16622 24.9026 7.20723 24.976 7.25645 25.0576L7.80606 22.7825H8.29005L7.46973 26.191L5.87833 24.1443L5.75528 23.973C5.71426 23.9078 5.68145 23.8507 5.65684 23.7773L5.10723 26.0606H4.62325V26.0687ZM8.24903 26.0687L9.03653 22.7825H9.56153L8.77403 26.0687H8.24903ZM9.52051 26.0687L10.308 22.7825H12.1045L11.9979 23.2391H10.7264L10.5295 24.0546H11.801L11.6861 24.5194H10.4147L10.0455 26.0606H9.52051V26.0687ZM11.8994 26.0687L12.6869 22.7825H13.2119L12.4244 26.0687H11.8994ZM13.1709 26.0687L13.9584 22.7825H15.7549L15.6482 23.2391H14.3768L14.1799 24.0627H15.4514L15.3365 24.5275H14.065L13.8107 25.5876H15.0822L14.9674 26.0687H13.1709ZM15.5744 26.0687L16.3619 22.7825H17.0674C17.5268 22.7825 17.8467 22.8069 18.019 22.8558C18.1912 22.9048 18.3389 22.9782 18.4537 23.0923C18.6014 23.2391 18.6998 23.4267 18.7408 23.6468C18.7818 23.8752 18.7654 24.1361 18.6998 24.4215C18.626 24.7151 18.5193 24.9679 18.3717 25.1962C18.224 25.4245 18.0354 25.6039 17.8139 25.7507C17.6498 25.8649 17.4693 25.9382 17.2725 25.9872C17.0838 26.0361 16.7967 26.0606 16.4193 26.0606H15.5744V26.0687ZM16.2143 25.5794H16.6572C16.8951 25.5794 17.0838 25.5631 17.215 25.5305C17.3463 25.4979 17.4611 25.4408 17.5678 25.3674C17.7154 25.2614 17.8385 25.1309 17.9369 24.9679C18.0354 24.8129 18.1092 24.6254 18.1584 24.4134C18.2076 24.2013 18.224 24.0219 18.1994 23.867C18.1748 23.7121 18.1174 23.5734 18.019 23.4674C17.9451 23.3859 17.8549 23.337 17.7318 23.3043C17.6088 23.2717 17.4201 23.2554 17.1494 23.2554H16.7721L16.2143 25.5794ZM21.1115 24.5927L20.7588 26.0687H20.2666L21.0541 22.7825H21.8498C22.0877 22.7825 22.2518 22.7988 22.3584 22.8232C22.465 22.8477 22.5471 22.8885 22.6127 22.9537C22.6947 23.0271 22.7522 23.1331 22.7768 23.2636C22.8014 23.394 22.7932 23.5327 22.7604 23.6876C22.7193 23.8425 22.6619 23.9893 22.5717 24.1198C22.4815 24.2503 22.3748 24.3563 22.26 24.4297C22.1615 24.4867 22.0549 24.5357 21.94 24.5601C21.8252 24.5846 21.6447 24.6009 21.415 24.6009H21.1115V24.5927ZM21.251 24.1524H21.3822C21.6693 24.1524 21.8744 24.1198 21.9893 24.0546C22.1041 23.9893 22.1779 23.8752 22.219 23.7121C22.26 23.5408 22.2354 23.4103 22.1533 23.3451C22.0631 23.2717 21.8826 23.2391 21.6119 23.2391H21.4807L21.251 24.1524ZM24.5404 26.0687L24.3764 25.2206H23.0967L22.5225 26.0687H21.9729L24.3518 22.652L25.09 26.0687H24.5404ZM23.4084 24.7721H24.3025L24.1549 24.0219C24.1467 23.973 24.1385 23.9159 24.1385 23.8588C24.1303 23.7936 24.1303 23.7284 24.1303 23.655C24.0975 23.7284 24.0647 23.7936 24.0236 23.8588C23.9908 23.9241 23.958 23.9812 23.9252 24.0301L23.4084 24.7721ZM25.8447 26.0687L26.2057 24.5683L25.5494 22.7906H26.099L26.5092 23.9078C26.5174 23.9404 26.5256 23.973 26.542 24.0219C26.5584 24.0709 26.5666 24.1198 26.583 24.1687L26.6815 24.0219C26.7143 23.973 26.7471 23.9322 26.7799 23.8915L27.7397 22.7906H28.2647L26.7307 24.5601L26.3697 26.0606H25.8447V26.0687ZM30.8404 24.446C30.8404 24.4215 30.8486 24.3481 30.865 24.234C30.8732 24.1361 30.8815 24.0627 30.8897 23.9975C30.8568 24.0709 30.824 24.1443 30.783 24.2258C30.742 24.2992 30.6928 24.3807 30.6354 24.4541L29.3721 26.2073L28.9619 24.4215C28.9455 24.3481 28.9291 24.2747 28.9209 24.2095C28.9127 24.1443 28.9045 24.0709 28.9045 24.0056C28.8881 24.0709 28.8635 24.1443 28.8389 24.2258C28.8143 24.2992 28.7815 24.3807 28.7404 24.4623L28.0022 26.0769H27.5182L29.1014 22.652L29.5525 24.7232C29.5607 24.7558 29.569 24.8129 29.5772 24.8863C29.5854 24.9597 29.6018 25.0576 29.6182 25.1717C29.6756 25.0739 29.7494 24.9597 29.8479 24.8129C29.8725 24.7721 29.8971 24.7477 29.9053 24.7232L31.3326 22.652L31.2834 26.0769H30.7994L30.8404 24.446ZM31.71 26.0687L32.4975 22.7825H34.294L34.1873 23.2391H32.9158L32.719 24.0627H33.9904L33.8756 24.5275H32.6041L32.3498 25.5876H33.6213L33.5065 26.0687H31.71ZM34.1053 26.0687L34.9256 22.652L36.4842 24.658C36.5252 24.7151 36.5662 24.7721 36.6072 24.8374C36.6483 24.9026 36.6893 24.976 36.7385 25.0576L37.2881 22.7825H37.7721L36.9518 26.191L35.3604 24.1443L35.2373 23.973C35.1963 23.9078 35.1635 23.8507 35.1389 23.7773L34.5893 26.0606H34.1053V26.0687ZM39.4455 23.2309L38.7647 26.0606H38.2397L38.9205 23.2309H38.0674L38.174 22.7743H40.4053L40.2986 23.2309H39.4455ZM39.9951 25.4082L40.4627 25.2125C40.4709 25.3593 40.5119 25.4734 40.6022 25.5468C40.6924 25.6202 40.8154 25.661 40.9795 25.661C41.1354 25.661 41.2666 25.6202 41.3815 25.5305C41.4963 25.4408 41.5701 25.3267 41.6029 25.1799C41.6522 24.9842 41.5373 24.8129 41.2584 24.6661C41.2174 24.6417 41.1928 24.6254 41.1682 24.6172C40.8565 24.4378 40.6596 24.2829 40.5775 24.1361C40.4955 23.9893 40.4791 23.8181 40.5283 23.6142C40.594 23.3451 40.7334 23.1331 40.9549 22.9618C41.1764 22.7988 41.4225 22.7091 41.7178 22.7091C41.9557 22.7091 42.1443 22.758 42.2838 22.8477C42.4232 22.9374 42.4971 23.076 42.5217 23.2473L42.0623 23.4593C42.0213 23.3533 41.9721 23.2799 41.9065 23.2309C41.8408 23.182 41.7588 23.1576 41.6604 23.1576C41.5209 23.1576 41.3979 23.1983 41.2994 23.2717C41.201 23.3451 41.1354 23.443 41.1025 23.5734C41.0533 23.7691 41.1928 23.9567 41.5127 24.1279C41.5373 24.1443 41.5537 24.1524 41.5701 24.1606C41.849 24.3073 42.0377 24.4541 42.1197 24.6009C42.2018 24.7477 42.2182 24.9189 42.169 25.1391C42.0951 25.449 41.9393 25.6936 41.7014 25.8812C41.4635 26.0606 41.1846 26.1584 40.8565 26.1584C40.5858 26.1584 40.3725 26.0932 40.2248 25.9627C40.0607 25.8322 39.9869 25.6447 39.9951 25.4082ZM43.8588 26.0687L44.6463 22.7825H45.1713L44.3838 26.0687H43.8588ZM45.1385 26.0687L45.9588 22.652L47.5174 24.658C47.5584 24.7151 47.5994 24.7721 47.6404 24.8374C47.6815 24.9026 47.7225 24.976 47.7717 25.0576L48.3213 22.7825H48.8053L47.985 26.191L46.3936 24.1443L46.2705 23.973C46.2295 23.9078 46.1967 23.8507 46.1721 23.7773L45.6225 26.0606H45.1385V26.0687ZM50.4787 23.2309L49.7979 26.0606H49.2729L49.9537 23.2309H49.1006L49.2072 22.7743H51.4385L51.3318 23.2309H50.4787ZM51.0447 26.0687L51.8322 22.7825H53.6369L53.5303 23.2391H52.2588L52.0619 24.0627H53.3334L53.2186 24.5275H51.9471L51.6928 25.5876H52.9643L52.8494 26.0687H51.0447ZM54.285 24.5927L53.9322 26.0606H53.44L54.2276 22.7743H54.9576C55.1709 22.7743 55.335 22.7906 55.4416 22.8151C55.5565 22.8395 55.6467 22.8885 55.7123 22.9537C55.7943 23.0352 55.8436 23.1331 55.8682 23.2636C55.8928 23.3859 55.8846 23.5245 55.8518 23.6794C55.7861 23.9404 55.6795 24.1524 55.5154 24.2992C55.3514 24.446 55.1463 24.5357 54.9002 24.5683L55.6467 26.0606H55.0561L54.3424 24.5927H54.285ZM54.4162 24.1769H54.5147C54.7936 24.1769 54.9822 24.1443 55.0889 24.079C55.1955 24.0138 55.2693 23.8996 55.3104 23.7284C55.3514 23.549 55.335 23.4185 55.2529 23.3451C55.1709 23.2717 54.9986 23.2309 54.7361 23.2309H54.6377L54.4162 24.1769ZM55.9666 26.0687L56.7541 22.7825H58.5506L58.444 23.2391H57.1725L56.9756 24.0546H58.2471L58.1322 24.5194H56.8608L56.4916 26.0606H55.9666V26.0687ZM60.2979 26.0687L60.1338 25.2206H58.8541L58.2799 26.0687H57.7303L60.1092 22.652L60.8475 26.0687H60.2979ZM59.1576 24.7721H60.0518L59.9041 24.0219C59.8959 23.973 59.8877 23.9159 59.8877 23.8588C59.8795 23.7936 59.8795 23.7284 59.8795 23.655C59.8467 23.7284 59.8139 23.7936 59.7729 23.8588C59.74 23.9241 59.7072 23.9812 59.6744 24.0301L59.1576 24.7721ZM64.26 23.5816C64.1451 23.4511 64.0057 23.3533 63.858 23.2962C63.7104 23.2309 63.5463 23.1983 63.3576 23.1983C63.0049 23.1983 62.6932 23.3125 62.4143 23.5408C62.1354 23.7691 61.9549 24.0709 61.8647 24.4378C61.7826 24.7885 61.8154 25.082 61.9795 25.3185C62.1354 25.5468 62.3815 25.661 62.7096 25.661C62.8983 25.661 63.0869 25.6284 63.2756 25.555C63.4643 25.4897 63.6529 25.3837 63.8498 25.2451L63.7022 25.8485C63.5381 25.9546 63.3658 26.0279 63.1854 26.0769C63.0049 26.1258 62.8244 26.1503 62.6275 26.1503C62.3815 26.1503 62.16 26.1095 61.9713 26.0279C61.7826 25.9464 61.6268 25.8241 61.5037 25.661C61.3807 25.5061 61.3068 25.3185 61.274 25.1065C61.2412 24.8945 61.2494 24.6661 61.315 24.4215C61.3725 24.1769 61.4709 23.9567 61.6022 23.7447C61.7334 23.5327 61.9057 23.3451 62.1026 23.1902C62.2994 23.0271 62.5127 22.9048 62.7424 22.8232C62.9721 22.7417 63.2018 22.7009 63.4397 22.7009C63.6283 22.7009 63.8006 22.7254 63.9647 22.7825C64.1205 22.8395 64.2682 22.9211 64.3994 23.0352L64.26 23.5816ZM64.3092 26.0687L65.0967 22.7825H66.8932L66.7865 23.2391H65.515L65.3182 24.0627H66.5897L66.4748 24.5275H65.2033L64.949 25.5876H66.2205L66.1057 26.0687H64.3092Z" fill="#3D3D3C" />
    <path d="M54.7605 19.9202H51.1593L56.1632 1.95581H59.7644L54.7605 19.9202ZM52.8902 2.51847C52.6441 2.17598 52.2585 2.00474 51.7335 2.00474H31.9476L30.9714 5.52748H48.9691L47.9191 9.28671H33.5226V9.27856H29.9214L26.9355 20.0017H30.5367L32.5382 12.8095H48.723C49.2316 12.8095 49.7074 12.6382 50.1503 12.2957C50.5933 11.9532 50.8886 11.5292 51.0281 11.0236L53.0296 3.83135C53.1855 3.29315 53.1363 2.86096 52.8902 2.51847ZM24.8355 18.7949C24.6386 19.5043 23.9824 20.0017 23.2441 20.0017H4.68042C4.17183 20.0017 3.79448 19.8305 3.54839 19.488C3.30229 19.1455 3.24487 18.7215 3.39253 18.2159L7.92065 2.00474H11.5218L7.47768 16.4871H21.8824L25.9265 2.00474H29.5277L24.8355 18.7949Z" fill="#70706E" />
    <path d="M65.9822 1.9884L70.535 10.991L60.9619 19.9936L65.9822 1.9884Z" fill="#098041" />
    <path d="M62.7834 1.9884L67.3361 10.991L57.7549 19.9936L62.7834 1.9884Z" fill="#E97626" />
  </svg>
);

const CardLogo = () => (
  <svg width="58" height="44" viewBox="0 0 58 44" fill="none">
    <rect x="2" y="6" width="54" height="36" rx="5" fill="#1E90FF" />
    <rect x="2" y="14" width="54" height="6" fill="#0B5BAA" />
    <rect x="8" y="28" width="14" height="6" rx="1" fill="#FFD700" />
  </svg>
);

const CashLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="30" viewBox="0 0 42 30" fill="none">
    <g clipPath="url(#clip0_728_805)">
      <path d="M24.4999 16.423C23.1025 16.423 21.9199 15.939 20.9519 14.971C19.9839 14.003 19.4999 12.8203 19.4999 11.423C19.4999 10.0256 19.9839 8.84296 20.9519 7.87496C21.9199 6.90696 23.1025 6.42296 24.4999 6.42296C25.8972 6.42296 27.0799 6.90696 28.0479 7.87496C29.0159 8.84296 29.4999 10.0256 29.4999 11.423C29.4999 12.8203 29.0159 14.003 28.0479 14.971C27.0799 15.939 25.8972 16.423 24.4999 16.423ZM11.3074 22.6155C10.3134 22.6155 9.46238 22.2615 8.75438 21.5535C8.04638 20.8455 7.69238 19.9943 7.69238 19V3.84596C7.69238 2.85196 8.04638 2.00096 8.75438 1.29296C9.46238 0.584957 10.3134 0.230957 11.3074 0.230957H37.6919C38.6862 0.230957 39.5374 0.584957 40.2454 1.29296C40.9534 2.00096 41.3074 2.85196 41.3074 3.84596V19C41.3074 19.9943 40.9534 20.8455 40.2454 21.5535C39.5374 22.2615 38.6862 22.6155 37.6919 22.6155H11.3074ZM14.3074 19.6155H34.6924C34.6924 18.6181 35.0464 17.7661 35.7544 17.0595C36.4624 16.3531 37.3134 16 38.3074 16V6.84596C37.3101 6.84596 36.4582 6.49196 35.7519 5.78396C35.0456 5.07596 34.6924 4.22496 34.6924 3.23096H14.3074C14.3074 4.22829 13.9534 5.08012 13.2454 5.78646C12.5374 6.49279 11.6864 6.84596 10.6924 6.84596V16C11.6897 16 12.5415 16.354 13.2479 17.062C13.9542 17.77 14.3074 18.6211 14.3074 19.6155ZM35.3459 29.6155H4.30788C3.31355 29.6155 2.46238 29.2615 1.75438 28.5535C1.04638 27.8455 0.692383 26.9943 0.692383 26V6.19246H3.69238V26C3.69238 26.1536 3.75638 26.2946 3.88438 26.423C4.01272 26.5513 4.15388 26.6155 4.30788 26.6155H35.3459V29.6155ZM11.3074 19.6155H10.6924V3.23096H11.3074C11.1407 3.23096 10.9965 3.29179 10.8749 3.41346C10.7532 3.53513 10.6924 3.67929 10.6924 3.84596V19C10.6924 19.1666 10.7532 19.3108 10.8749 19.4325C10.9965 19.5545 11.1407 19.6155 11.3074 19.6155Z" fill="#931314" />
    </g>
    <defs>
      <clipPath id="clip0_728_805">
        <rect width="42" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

type PaymentMethod = "upi" | "card" | "cash" | null;

const PaymentDetail = () => {
  const navigate = useNavigate();
  const { tableNo = "T1" } = useParams<{ tableNo: string }>();
  const [offer, setOffer] = useState("");
  const [note, setNote] = useState("");
  const [tip, setTip] = useState<number | null>(12);
  const [customTip, setCustomTip] = useState("");
  const [method, setMethod] = useState<PaymentMethod>(null);
  const [showOffers, setShowOffers] = useState(false);

  const applyOffer = (code: string) => {
    setOffer(code);
    setShowOffers(false);
  };

  const subtotal = useMemo(() => ITEMS.reduce((acc, it) => acc + it.price * it.qty, 0), []);
  const delivery = 0;
  const discount = 34;
  const tax = 9;
  const total = subtotal + delivery - discount + tax;

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full bg-black flex justify-center">
        <div className="relative w-full min-h-screen overflow-hidden" style={{ backgroundColor: "#F4F4F5" }} >
          {/* Header */}
          <SubHeader
            title="Payment Detail"
            rightSlot={
              <p className="font-sansation font-bold text-[#111] text-[14px]">
                Table Number - {tableNo}
              </p>
            }
          />

          <div className="px-3 pt-3 pb-[120px] flex flex-col gap-3">
            {/* Item cards */}
            <div className="flex flex-col gap-3">
              {ITEMS.map((it) => (
                <article key={it.id} className="bg-white rounded-[6px] border border-[#E6EEFF] p-3 flex flex-col gap-1.5 relative" >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <VegIcon type={it.type} size={18} />
                      <h3 className="font-sansation font-bold text-[#111] text-[16px]">
                        Dish Code : {it.code}
                      </h3>
                    </div>
                    <p className="font-sansation font-bold text-[#F15A29] text-[16px]">
                      ₹ {(it.price * it.qty).toFixed(2)}
                    </p>
                  </div>
                  <p className="font-opensans text-[16px] text-[rgba(17,17,17,0.8)]">
                    {it.name}
                  </p>
                  <div className="flex items-center justify-between">
                    <p className="font-opensans text-[12px] text-[#111]">
                      Qty- {it.qty}
                    </p>
                    <p className="font-opensans text-[12px] text-[rgba(17,17,17,0.6)]">
                      Ordered at {it.orderedAt}
                    </p>
                  </div>
                </article>
              ))}
            </div>

            {/* Offer Code */}
            <section className="flex flex-col gap-3">
              <div className="flex items-center justify-between -mb-2">
                <h3 className="font-sansation font-bold text-[#1F2024] text-[16px]">
                  Offer Code
                </h3>
                <button
                  type="button"
                  className="font-sansation font-bold text-[12px] uppercase tracking-[-0.24px] bg-transparent border-0"
                  style={{ color: "#F15A29" }}
                >
                  View All
                </button>
              </div>
              <div className="relative">
                <TextInput
                  type="text"
                  value={offer}
                  onChange={(e) => setOffer(e.target.value)}
                  placeholder="Enter Offer Code"
                  className="pr-20"
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 font-sansation font-bold text-[14px] bg-transparent border-0"
                  style={{ color: "#F15A29" }}
                >
                  APPLY
                </button>
              </div>
              <button
                type="button"
                onClick={() => setShowOffers(true)}
                className="w-full h-[47px] rounded-[6px] bg-white border border-[#E6EEFF] flex items-center justify-between px-3"
              >
                <span className="flex items-center gap-2 font-opensans font-semibold text-[14px] text-[rgba(17,17,17,0.8)]">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M3 12h18M12 8v13M8 8a3 3 0 110-6c1.5 0 2.5 1 4 3 1.5-2 2.5-3 4-3a3 3 0 110 6H8z" stroke="#F15A29" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <rect x="3" y="8" width="18" height="13" rx="2" stroke="#F15A29" strokeWidth="2" />
                    <path d="M3 12h18M12 8v13" stroke="#F15A29" strokeWidth="2" />
                  </svg>
                  View more offers
                </span>
                <ChevronRight />
              </button>
            </section>

            {/* Billing */}
            <BillingDetails
              subtotal={subtotal}
              tax={tax}
              total={total}
              rows={[
                { label: "Cart Total", value: `₹${subtotal.toFixed(2)}` },
                { label: "Delivery Charges", value: `₹${delivery.toFixed(2)}` },
                { label: "Discounted Amount", value: `- ₹${discount.toFixed(2)}` },
                { label: "Tax Amount", value: `+ ₹${tax.toFixed(2)}` },
              ]}
            />

            {/* Special Request */}
            <section className="flex flex-col gap-2">
              <h3 className="font-sansation font-bold text-[#1F2024] text-[16px]">
                Special Request
              </h3>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Enter Note"
                rows={3}
                className="w-full resize-none h-24 rounded-[6px] border bg-white px-4 py-3 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098]"
                style={{ borderColor: "#C5C6CC" }}
              />
            </section>

            {/* Tip */}
            <section className="flex flex-col gap-2">
              <h3 className="font-sansation font-bold text-[#1F2024] text-[16px]">
                Tip your Service Staff
              </h3>
              <div className="bg-white rounded-[6px] border border-[#E6EEFF] p-3 flex flex-col gap-3">
                <TextInput
                  type="text"
                  value={customTip}
                  onChange={(e) => setCustomTip(e.target.value)}
                  placeholder="Enter Tip"
                />
                <div className="flex gap-2">
                  {TIPS.map((t) => {
                    const selected = tip === t;
                    const isMostTipped = t === 12;
                    return (
                      <button
                        key={t}
                        type="button"
                        onClick={() => {
                          setTip(t);
                          setCustomTip("");
                        }}
                        className={`relative flex-1 overflow-hidden rounded-[6px] border font-opensans text-[12px] text-[#1F2024] bg-white flex items-center justify-center ${isMostTipped ? "h-[50px]" : "h-[41px]"
                          }`}
                        style={{
                          borderColor: selected ? "#F15A29" : "#DDDDDD",
                          color: selected ? "#F15A29" : "#1F2024",
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        <span className={isMostTipped ? "pb-[17px]" : ""}>
                          ₹{t.toFixed(2)}
                        </span>
                        {isMostTipped && (
                          <span className="absolute left-0 right-0 bottom-0 h-[17px] flex items-center justify-center font-opensans text-[9px] text-white" style={{ backgroundColor: "#F15A29" }} >
                            Most Tipped
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </section>

            {/* Choose Payment Method */}
            <section className="flex flex-col gap-3">
              <h3 className="font-sansation font-bold text-[#1F2024] text-[16px]">
                Choose Payment Method
              </h3>
              <div className="flex gap-3">
                <MethodCard
                  selected={method === "upi"}
                  onClick={() => {
                    setMethod("upi");
                    navigate(`/mobile/qr-code/${tableNo}?amount=${total.toFixed(2)}`);
                  }}
                  label="UPI"
                >
                  <UpiLogo />
                </MethodCard>
                <MethodCard
                  selected={method === "card"}
                  onClick={() => {
                    setMethod("card");
                    navigate(`/mobile/receipt/${tableNo}?amount=${total.toFixed(2)}`);
                  }}
                  label="Card"
                >
                  <CardLogo />
                </MethodCard>
                <MethodCard selected={method === "cash"}
                  onClick={() => {
                    setMethod("cash"); navigate(`/mobile/receipt/${tableNo}?amount=${total.toFixed(2)}`);
                  }}
                  label="Cash"
                >
                  <CashLogo />
                </MethodCard>
              </div>
            </section>

          </div>

          {/* Offers Popup */}
          {showOffers && (
            <div className="fixed inset-0 z-[60] flex items-end justify-center" onClick={() => setShowOffers(false)} >
              <div className="absolute inset-0 backdrop-blur-sm" style={{ backgroundColor: "rgba(0,0,0,0.7)" }} />
              <div className="relative w-full max-w-[430px] bg-white rounded-t-[20px] max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()} >
                <div className="flex items-center justify-between px-4 pt-3 pb-2">
                  <h2 className="font-sansation font-bold text-[#1F2024] text-[18px]">
                    Available Offers
                  </h2>
                  <button
                    type="button"
                    aria-label="Close"
                    onClick={() => setShowOffers(false)}
                    className="w-8 h-8 flex items-center justify-center bg-transparent border-0 text-[#717171] text-[22px] leading-none"
                  >
                    ×
                  </button>
                </div>
                <div className="overflow-y-auto px-4 pb-6 pt-0 flex flex-col gap-3">
                  {OFFERS.map((o) => (
                    <div key={o.code}
                      className="relative bg-white rounded-[10px] border border-[#E6EEFF] h-[170px] overflow-hidden"
                    >
                      {/* Left red strip with vertical % OFF */}
                      <div className="absolute left-0 top-0 bottom-0 w-[40px] rounded-l-[10px] flex items-center justify-center"
                        style={{ backgroundColor: "#931314" }}
                      >
                        <p className="font-sansation font-bold text-white text-[20px] whitespace-nowrap" style={{ transform: "rotate(-90deg)" }}>
                          {o.percent}% OFF
                        </p>
                      </div>
                      {/* Content */}
                      <div className="absolute left-[52px] right-3 top-[14px] flex flex-col gap-1">
                        <p className="font-sansation font-bold text-[#222] text-[16px]">
                          {o.code}
                        </p>
                        <p className="font-opensans text-[#717171] text-[14px] leading-tight">
                          {o.description}
                        </p>
                      </div>
                      {/* Dashed divider */}
                      <div className="absolute left-[40px] right-0 top-[125px]" style={{ borderTop: "1px dashed #DDDDDD" }} />
                      {/* APPLY button */}
                      <button
                        type="button"
                        onClick={() => applyOffer(o.code)}
                        className="absolute right-4 bottom-3 font-sansation font-bold text-[16px] bg-transparent border-0"
                        style={{ color: "#F15A29" }}
                      >
                        APPLY
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Sticky CTA */}
          <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full bg-white px-3 py-4 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] flex gap-3">
            <button
              type="button"
              onClick={() => navigate(`/mobile/split-bill/${tableNo}`)}
              className="flex-1 rounded-[6px] py-3.5 bg-white border-2 font-sansation font-bold text-[14px] tracking-[-0.28px] uppercase"
              style={{ borderColor: "#F15A29", color: "#F15A29" }}
            >
              Split Bill
            </button>
            <button
              type="button"
              onClick={() => navigate("/mobile/order-success")}
              className="flex-1 rounded-[6px] py-3.5 font-sansation font-bold text-[14px] tracking-[-0.28px] uppercase text-white border-0"
              style={{ backgroundColor: "#F15A29" }}
            >
              Pay ₹{total.toFixed(2)}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const MethodCard = ({ selected, onClick, label, children }: { selected: boolean; onClick: () => void; label: string; children: React.ReactNode }) => (

  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    className="flex-1 aspect-square rounded-[6px] bg-white border-2 flex items-center justify-center"
    style={{ borderColor: selected ? "#F15A29" : "rgba(241,90,41,0.4)", borderWidth: selected ? 2 : 1 }}>
    {children}
  </button>
);

export default PaymentDetail;
